import { apiClient } from '../utils/api-client';
import type { Follower } from '../types/user';

/** The API path segment of each thing a member can follow. */
export type FollowableKind = 'gyms' | 'crags' | 'trophies' | 'users';

export interface FollowersPage {
  followers: Follower[];
  total: number;
  hasMore: boolean;
}

interface FollowersResponse {
  data: { id: string; type: 'user'; attributes: Follower }[];
  meta: { page: number; per_page: number; total: number; has_more: boolean };
}

/**
 * The full followers list of a profile, newest first, in pages. The profile
 * payload itself only carries a short preview plus `followers_count`; this is
 * what the "and N others" dialog loads.
 */
export const followersService = {
  async list(kind: FollowableKind, slug: string, page: number = 1): Promise<FollowersPage> {
    const response = await apiClient.get(`/api/${kind}/${slug}/followers?page=${page}`);

    if (!response.ok) {
      throw new Error('Failed to fetch followers');
    }

    const json = (await response.json()) as FollowersResponse;
    return {
      followers: json.data.map((row) => row.attributes),
      total: json.meta.total,
      hasMore: json.meta.has_more,
    };
  },
};
